<template>
  <div class="app-tariff-info" v-if="bookedTariff.tariffExtra">
    <h2 class="tariff-name">{{ bookedTariff.name }}</h2>
    <div class="tariff-info-text">
      <slot name="txtBefore"></slot>
      <div class="contract-start-date">
        <slot name="labelContractDate">Aktiv seit: </slot>
        <span class="tariff-start-date">{{ formattedContractStartDate }}</span>
      </div>
      <div v-if="bookedTariff.terminationDate" class="termination-date">
        <slot name="labelTerminationDate">Gekündigt zum: </slot>
        <span class="tariff-termination-date">{{ formattedTerminationDate }}</span>
      </div>
      <slot name="txtAfter"></slot>
    </div>
    <button :class="['btn', 'tariff-btn', 'tariff-btn-' + bookedTariff.tariffId]" @click="showInfo">
      Tarif-Info
    </button>
  </div>
</template>

<script>

export default {
  name: 'TariffInfo',
  props: {
    bookedTariff: {
      type: Object,
      default: null
    }
  },
  methods: {
    showInfo () {
      this.$emit('show-info')
    }
  },
  computed: {
    formattedContractStartDate () {
      return this.$config.calendar.formatter.dateFormatter.format(new Date(this.bookedTariff.contractStartDate))
    },
    formattedTerminationDate () {
      return this.$config.calendar.formatter.dateFormatter.format(new Date(this.bookedTariff.terminationDate))
    }
  }
}
</script>
